import { createBrowserRouter, Outlet } from 'react-router-dom';
import { AuthRoutes } from '../../modules/Auth/routes';
import { DisciplinesRoutes } from '../../modules/Disciplines/routes';
import { FavoritoRoutes } from '../../modules/Favorites/routes';
import { MyAreaRoutes } from '../../modules/MyArea/routes';
import { ProfileRoutes } from '../../modules/Profile/routes';
import { SearchRoutes } from '../../modules/Search/routes';
import { AuthenticatedLayout } from '../components/templates/AuthenticatedLayout';
import ErrorPage from '../components/templates/ErrorPage';
import Template from '../templates/baseApp';
import RedirectRoutes from '../../modules/Redirect/routes';

const Router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthenticatedLayout>
        <Template>
          <Outlet />
        </Template>
      </AuthenticatedLayout>
    ),
    children: [...MyAreaRoutes],
  },
  {
    path: '/',
    element: <Outlet />,
    children: AuthRoutes,
  },
  {
    path: 'favoritos',
    element: (
      <AuthenticatedLayout>
        <Template>
          <Outlet />
        </Template>
      </AuthenticatedLayout>
    ),
    children: FavoritoRoutes,
  },
  {
    path: 'search',
    element: (
      <AuthenticatedLayout>
        <Template>
          <Outlet />
        </Template>
      </AuthenticatedLayout>
    ),
    children: SearchRoutes,
  },
  {
    path: 'disciplinas',
    element: (
      <AuthenticatedLayout>
        <Template>
          <Outlet />
        </Template>
      </AuthenticatedLayout>
    ),
    children: DisciplinesRoutes,
  },
  {
    path: 'perfil',
    element: (
      <AuthenticatedLayout>
        <Template>
          <Outlet />
        </Template>
      </AuthenticatedLayout>
    ),
    children: ProfileRoutes,
  },
  {
    path: 'redireciona',
    element: (
      <AuthenticatedLayout>
        <Outlet/>
      </AuthenticatedLayout>
    ),
    children: RedirectRoutes,
  },
  {
    path: '*',
    element: <ErrorPage />,
  },
]);

export default Router;
